import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  computed,
  ref,
  watch,
  onMounted,
  nextTick,
} from 'vue'
import { useI18n } from 'vue-i18n'
import { AmountType, ActivityType } from '@/types/types'
import FormRulesFactory from '@/common/formRules'
import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent } from 'vue'
import { number } from 'echarts'

const __default__ = defineComponent({
  name: 'ActivityTmplItems',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  isEdit: {
    type: Boolean,
  },
  activityType: {
    type: Number,
    required: true,
  },
  amountType: {
    type: Number,
  },
  list: {
    type: Array,
    required: false,
    default: () => [],
  },
},
  emits: ['update:list'],
  setup(__props, { expose, emit }) {

const props = __props

const { t } = useI18n()
const { tl } = useI18nTl('formRules')



const activityTmplitemsFormRule = ref({
  ...FormRulesFactory.generateCustomRules(['amount'], 'inputEmpty', 'inputInvalid', {
    pattern: /^\d+(\.\d{1,2})?$/,
    maxDecimalPlaces: 2,
  }),
  ...FormRulesFactory.generateCustomRules(['val'], 'inputEmpty', 'inputInvalid', {
    pattern: /^\d+(\.\d{1,2})?$/,
    maxDecimalPlaces: 2,
  }),
})

// 初始化规则
// console.log('🚀 ~ activityTmplitemsFormRule:', activityTmplitemsFormRule.value)
const topicForm = ref()
expose({
  validate: async () => {
    await nextTick()
    if (topicForm.value) {
      return topicForm.value.validate()
    } else {
      throw new Error('topicForm not initialized')
    }
  },
  resetFields: async () => {
    await nextTick()
    if (topicForm.value) {
      topicForm.value.resetFields()
    } else {
      throw new Error('topicForm not initialized')
    }
  },
  clearValidate: async () => {
    await nextTick()
    if (topicForm.value) {
      topicForm.value.clearValidate()
    } else {
      throw new Error('topicForm not initialized')
    }
  },
})
const disabled = ref(props.isEdit)
const feeModel = ref<Record<string, any>>({})
const feeList = computed({
  get: () => props.list,
  set: (val: any) => {
    emit('update:list', val)
  },
})

const addItem = () => {
  let tmp = {
    amount: null,
    val: null,
  }
  feeList.value.push(tmp)
}

const disableAdd = () => {
  return feeList.value.length >= 8
}

const delItem = (row) => {
  feeList.value.forEach((v, k) => {
    if (v === row) {
      feeList.value.splice(k, 1)
    }
  })
}

watch(
  () => props.isEdit,
  (val) => {
    disabled.value = val
  },
  { immediate: true }, // 立即执行，确保初始加载时也同步
)

watch(
  () => props.list,
  (newList) => {
    feeList.value = [...newList]
    feeModel.value.feeList = [...newList]
  },
  { immediate: true, deep: true }, // 立即执行，确保初始加载时也同步
)
watch(
  () => props.activityType,
  (newVal) => {
    if (props.activityType == ActivityType.AT_REBATE_DISCOUNT) {
      activityTmplitemsFormRule.value.val.push({
        pattern: /^(0(\.\d+)?|1(\.0+)?)$/,
        message: tl('inputRangeInvalid', { min: 0, max: 1 }),
      })
      console.log('🚀 ~ activityTmplitemsFormRule:', activityTmplitemsFormRule.value)
    }
  },
  { immediate: true, deep: true }, // 立即执行，确保初始加载时也同步
)

const amountLabel = computed(() => {
  if (props.activityType == ActivityType.AT_RECHARGER_GIFT) {
    return t('Operation.rechargeAmount')
  }

  return t('Operation.thresholdAmount')
})

const valLabel = computed(() => {
  if (props.activityType == ActivityType.AT_RECHARGER_GIFT) {
    return t('Operation.giftAmount')
  }

  if (props.activityType == ActivityType.AT_REBATE_DISCOUNT) {
    return t('Operation.proportionOfDiscount')
  }
  return t('Operation.discountsAmount')
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "topicForm",
    ref: topicForm,
    model: feeModel.value,
    "validate-on-rule-change": false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table, {
        data: _unref(feeList),
        class: "shadow-none",
        "row-style": { height: '56px' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, { label: _unref(amountLabel) }, {
            default: _withCtx(({ row, $index }) => [
              _createVNode(_component_el_form_item, {
                prop: `feeList.${$index}.amount`,
                rules: activityTmplitemsFormRule.value.amount
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "number",
                    min: 0,
                    modelValue: row.amount,
                    "onUpdate:modelValue": ($event: any) => ((row.amount) = $event),
                    disabled: disabled.value,
                    placeholder: "100.00"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                _: 2
              }, 1032, ["prop", "rules"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, { label: _unref(valLabel) }, {
            default: _withCtx(({ row, $index }) => [
              _createVNode(_component_el_form_item, {
                prop: `feeList.${$index}.val`,
                rules: activityTmplitemsFormRule.value.val
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "number",
                    min: 0,
                    modelValue: row.val,
                    "onUpdate:modelValue": ($event: any) => ((row.val) = $event),
                    disabled: disabled.value,
                    placeholder: "50.00"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                _: 2
              }, 1032, ["prop", "rules"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, { width: "80" }, {
            header: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                size: "small",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (addItem())),
                disabled: disableAdd(scope) || !_ctx.$hasPermission('post') || disabled.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.add')), 1)
                ]),
                _: 2
              }, 1032, ["disabled"])
            ]),
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_button, {
                size: "small",
                disabled: !_ctx.$hasPermission('delete') || disabled.value,
                onClick: ($event: any) => (delItem(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.delete')), 1)
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})